import styled from "styled-components";
import {ExperienceLevel, StyledBaseProps} from "@betrue/shared/interfaces";

const color = "#0094ba"
export interface ExperienceViewProps extends StyledBaseProps {
  level: ExperienceLevel,
  onSelect?:(exp: ExperienceLevel) => void
}

export const ExperienceView = styled(({level, onSelect, className}: ExperienceViewProps) => (
  <span className={className}>

    {onSelect ?
      <>
      <span
        onClick={(e) => onSelect(ExperienceLevel.ENTRY)}
        className={[ExperienceLevel.ENTRY, ExperienceLevel.INTERMEDIATE, ExperienceLevel.EXPERT].includes(level) ? 'highlight' : ''}/>
        <span
          onClick={(e) => onSelect(ExperienceLevel.INTERMEDIATE)}
          className={[ExperienceLevel.INTERMEDIATE, ExperienceLevel.EXPERT].includes(level) ? 'highlight' : ''}/>
        <span
          onClick={(e) => onSelect(ExperienceLevel.EXPERT)}
          className={[ExperienceLevel.EXPERT].includes(level) ? 'highlight' : ''}/>
      </>
      :
      <>
        <span
          className={[ExperienceLevel.ENTRY, ExperienceLevel.INTERMEDIATE, ExperienceLevel.EXPERT].includes(level) ? 'highlight' : ''}/>
        <span
          className={[ExperienceLevel.INTERMEDIATE, ExperienceLevel.EXPERT].includes(level) ? 'highlight' : ''}/>
        <span
          className={[ExperienceLevel.EXPERT].includes(level) ? 'highlight' : ''}/></>}
  </span>
))`
  align-items: center;
  display: flex;
  height: 4px;
  width: 100%;
  margin-top: 2px;
  margin-bottom: 2px;

  & .highlight {
    background-color: ${color};
  }

  & span {
    border-radius: 6px;
    display: block;
    cursor: ${(props) => props.onSelect ? 'pointer' : ''};
    background-color: #c0c4c9;
    height: 3px;
    margin-right: 2px;
    line-height: 4px;
    width: 25px;
  }



`
